module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapsible",
    class: _vm.stateClass,
    attrs: {
      "id": "fournitures"
    }
  }, [_c('div', {
    staticClass: "collapsible-head wrap",
    attrs: {
      "id": "head-fournitures"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('openCollapsible', 'fournitures')
      }
    }
  }, [_vm._v("\n        FOURNITURES\n        "), _c('i', {
    staticClass: "icon-go"
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapsible-body wrap",
    attrs: {
      "id": "lst-fournitures"
    }
  }, [_c('ul', {
    staticClass: "list-pieces"
  }, _vm._l((_vm.fournitures), function(f) {
    return _c('li', {
      key: f.id,
      staticClass: "piece"
    }, [_c('div', {
      staticClass: "identification"
    }, [_c('strong', [_vm._v(_vm._s(f.designation))]), _vm._v(" \n                    "), (f.etat) ? _c('span', [_vm._v("(" + _vm._s(f.etat) + ")")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_vm._v(_vm._s(f.qte) + " "), (f.prix) ? _c('span', [_vm._v("x " + _vm._s(f.prix) + "€ HT")]) : _vm._e()]), _vm._v(" "), _c('a', {
      staticClass: "btn delete",
      attrs: {
        "href": "javascript: void 0"
      },
      on: {
        "click": function($event) {
          return _vm.deletePiece(f.id)
        }
      }
    }, [_c('i', {
      staticClass: "icon-delete"
    })])])
  }), 0), _vm._v(" "), _c('a', {
    staticClass: "btn add-manip",
    attrs: {
      "href": "javascript: void 0;",
      "id": "add-piece"
    },
    on: {
      "click": _vm.addPiece
    }
  }, [_vm._v("\n            Ajouter une fourniture\n            "), _c('i', {
    staticClass: "icon-add"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31b59ee1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fiches/bsdd/subcomponents/GestionPieces.vue
// module id = 749
// module chunks = 0